import {
  type CustomObjectQueries,
  defCustomObjectQueries,
} from '@kizen/query/custom-object';
import AxiosService from '__services/AxiosService';

const queries: CustomObjectQueries = defCustomObjectQueries(AxiosService);

export const allCustomObjectsQuery: CustomObjectQueries['allCustomObjectsQuery'] =
  queries.allCustomObjectsQuery;

export const allCustomObjectFieldsQuery: CustomObjectQueries['allCustomObjectFieldsQuery'] =
  queries.allCustomObjectFieldsQuery;

export const customObjectCategoriesQuery: CustomObjectQueries['customObjectCategoriesQuery'] =
  queries.customObjectCategoriesQuery;

export const customObjectDetailQuery: CustomObjectQueries['customObjectDetailQuery'] =
  queries.customObjectDetailQuery;

export const customObjectFieldsQuery: CustomObjectQueries['customObjectFieldsQuery'] =
  queries.customObjectFieldsQuery;

export const customObjectModelQuery: CustomObjectQueries['customObjectModelQuery'] =
  queries.customObjectModelQuery;
